module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av342-9a31afc45c08ab25784cb331346a2569.jpg";